import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
	apiKey: 'AIzaSyC73vRyAC_1lOpyxnigjIGHn1nUZbwo61M',
	authDomain: 'chatapp-1ba72.firebaseapp.com',
	projectId: 'chatapp-1ba72',
	storageBucket: 'chatapp-1ba72.appspot.com',
	messagingSenderId: '110885372835',
	appId: '1:110885372835:web:2973351cf84d98eabc9016',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore();
